import { useEffect, useState } from 'react';
import styles from './ConfirmDialog.module.css';

interface ConfirmDialogProps {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * 自定义确认对话框，替代 window.confirm
 */
export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  title = '提示',
  message,
  confirmText = '确定',
  cancelText = '取消',
  danger = false,
  onConfirm,
  onCancel,
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onCancel, 250);
  };

  const handleConfirm = () => {
    setVisible(false);
    setTimeout(onConfirm, 250);
  };

  return (
    <div className={`${styles.overlay} ${visible ? styles.visible : ''}`} onClick={handleClose}>
      <div className={`${styles.dialog} ${visible ? styles.visible : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className={styles.body}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.message}>{message}</p>
        </div>
        <div className={styles.actions}>
          <button className={styles.cancelBtn} onClick={handleClose}>{cancelText}</button>
          <button
            className={`${styles.confirmBtn} ${danger ? styles.danger : ''}`}
            onClick={handleConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};
